export const FIELD_ACTIVE_VALUE_KEY = 'value'

// FIELD_ACTIVE_VALUE_KEY to select a single color value

// Narrows the floating position reference to the start of the (full-width)
// field, so the `right`/`left` fallback placements land near the field
// instead of past its far edge — see useColorPickerFieldPopover
export const FIELD_POPOVER_POSITION_REFERENCE_WIDTH = 40
